import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb'; 
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs'; 
import { FunctionService } from 'vhobjects-service/src/services';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'atw-bill-code-config',
  templateUrl: './bill-code-config.component.html',
  styleUrls: ['./bill-code-config.component.scss']
})

export class AtwBillCodeConfig  implements OnInit {
  @Input() type_config : string; // xác định trang đang ở page hay preview
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    },
    {
      title: 'cau_hinh_bo_goc',
      index: 2,
    }
  ];

  customize = []
  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};
  dataAfterChange: any  = {}
  arr_link_page: any;
  id_subproject: any = "";

  /**
   * Mảng chứa kiểu đường dẫn
   */
  link_type: any = [
    {
      name: 'Mở trong trang mới',
      value: '_blank'
    },
    {
      name: 'Mở trong trang hiện tại',
      value: '_self'
    }
  ]

  // private textFormatDiffer: KeyValueDiffer<string, any>;
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private route: ActivatedRoute,
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { 
  }

  ngOnInit(): void {
    if (!this.config['background-image'])
      this.config['background-image'] = {
        "gradient_check": false,
        "background_image_direction": "to left,",
        "background_image_background_color": "#8c52ff",
        "background_image_arr_gradient": [
          "rgb(0, 0, 255)",
          "rgb(255, 255, 0)"
        ],
        "background_image_opacity": "100"
      }
    
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'),
    ]) .subscribe(([fonts, effects]:any)=>{
      this.fonts = fonts;
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e  => e.type == this.staticdata.animation_type);
    })
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  ngOnDestroy(){
    this.saveDataProperties();
  }

  /**
   * Cập nhật text-shadow
   */
  handleSetTextShadow() {
    this.class['bill-code__wrapper']['filter'] = `drop-shadow(${this.config['filter']['offset_x']}px ${this.config['filter']['offset_y']}px ${this.config['filter']['blur_radius']}px ${this.config['filter']['shadow_color']})`;
  }

  /** Định dạng hiệu ứng văn bản (phong cách và kiểu cọ)
   * @param action : trả về hiệu ứng văn bản đã chọn
   */
  dispatchStyles(action) {
    // reset những style khác trước
    switch (action) {
      case 'Đổ bóng':
        this.config['text_style'] = 'shadow';
        this.class['bill-code__content']['-webkit-text-stroke-width'] = "0";
        this.class['bill-code__wrapper']['background-color'] = "";
        this.class['bill-code__wrapper']['border-top-left-radius'] = "0px";
        this.class['bill-code__wrapper']['border-top-right-radius'] = "0px";
        this.class['bill-code__wrapper']['border-bottom-right-radius'] = "0px";
        this.class['bill-code__wrapper']['border-bottom-left-radius'] = "0px";
        this.handleSetTextShadow();
        break;

      case 'Tạo stroke':
        this.config['text_style'] = 'stroke';
        this.class['bill-code__wrapper']['filter'] = "";
        this.class['bill-code__wrapper']['background-color'] = "";
        this.class['bill-code__wrapper']['border-top-left-radius'] = "0px";
        this.class['bill-code__wrapper']['border-top-right-radius'] = "0px";
        this.class['bill-code__wrapper']['border-bottom-right-radius'] = "0px";
        this.class['bill-code__wrapper']['border-bottom-left-radius'] = "0px";
        this.class['bill-code__content']['-webkit-text-stroke-width'] = '2px';
        break;

      case 'background':
        this.config['text_style'] = 'background';
        this.class['bill-code__content']['-webkit-text-stroke-width'] = "0";
        this.class['bill-code__wrapper']['filter'] = "";
        this.class['bill-code__wrapper']['background-color'] = "#008848";
        break;

      default:
        this.config['text_style'] = '';
        this.class['bill-code__content']['-webkit-text-stroke-width'] = "0";
        this.class['bill-code__wrapper']['filter'] = "";
        this.class['bill-code__wrapper']['background-color'] = "";
        this.class['bill-code__wrapper']['border-top-left-radius'] = "0px";
        this.class['bill-code__wrapper']['border-top-right-radius'] = "0px";
        this.class['bill-code__wrapper']['border-bottom-right-radius'] = "0px";
        this.class['bill-code__wrapper']['border-bottom-left-radius'] = "0px";
    }

    this.updateObject();
  }

  // GRADIENT
  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image']['gradient_check']) {
      this.class['bill-code__content']['background-image'] = `linear-gradient(${this.config['background-image']['background_image_direction']} ${this.config['background-image']['background_image_arr_gradient']})`;
      this.class['bill-code__content']['-webkit-text-fill-color'] = 'transparent';
      this.class['bill-code__content']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['bill-code__content']['background-image'] = 'none';
      this.class['bill-code__content']['-webkit-text-fill-color'] = 'unset';
      this.class['bill-code__content']['-webkit-background-clip'] = 'unset';
    }

    this.updateClass();
    this.updateConfig();
  }

  openbgGradient() {
    if (isPlatformBrowser(this.platformId)) document.getElementById('input-gradient').click();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    this.config['background-image']['background_image_direction'] = direction.direction;
    this.handleSetGradientText();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['background_image_opacity'] = e.target.value;
    const newArr = this.config['background-image']['background_image_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['background_image_opacity'] / 100})`
    })
    this.config['background-image']['background_image_arr_gradient'] = newArr;

    this.handleSetGradientText();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradient() {
    this.config['background-image']['background_image_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['background_image_background_color'])}, ${this.config['background-image']['background_image_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['background_image_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }
  
  // /**
  //  * Hàm update class
  //  */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  // /**
  //  * Hàm update config
  //  */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
  }

  // /**
  //  * Hàm update object vào database.
  //  */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }

  /**
   * Set style changed
   * @param name : tên trường data cần lưu
   * @param value : giá trị data
   */
  updateCss(name,key){
    this.dataAfterChange[name] = {...key}
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };


  /**
   * Cập nhật lưu data vào database.
   */
  saveDataProperties() {
    if (Object.keys(this.dataAfterChange).length){
      if (this.type == 'admin') {
              if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
        if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata')
        return;
      }
      this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, this.dataAfterChange)
        .then((bool) => {
          
        }, error => {
          console.error(error)
        })
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event){
    if(event.width) this.class['text']['width'] = event.width + 'px';
    if(event.height) this.class['text']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  /**
   * Hàm này set customize mở mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    
    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.styles_field[0]);
    }
  }
}
